module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_02_1000.4aaaad96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_02_1000.jpg
// module id = 352
// module chunks = 0